import type { Visita } from '../db/tipos'

export type MotivoSemPedido = NonNullable<Visita['motivo_sem_pedido']>

// A ordem e a do <select> na tela: do mais comum ao menos.
export const MOTIVOS_SEM_PEDIDO: ReadonlyArray<MotivoSemPedido> = [
  'fechado', 'sem_necessidade', 'estoque_cheio', 'preco_alto', 'concorrente', 'outro',
]

export const ROTULO_MOTIVO: Record<MotivoSemPedido, string> = {
  fechado: 'Estava fechado',
  sem_necessidade: 'Sem necessidade',
  estoque_cheio: 'Estoque cheio',
  preco_alto: 'Achou caro',
  concorrente: 'Comprou do concorrente',
  outro: 'Outro motivo',
}

export type SituacaoVisita = 'pendente' | 'comprou' | 'volta_depois' | 'perdeu' | 'outro'

// Os grupos sao dela (08/08): amarelo = nao vendi mas o cliente segue meu;
// vermelho = perdi a venda para preco ou concorrente. O SELO mostra o motivo
// exato; o grupo so decide a cor.
const GRUPO_DO_MOTIVO: Record<MotivoSemPedido, SituacaoVisita> = {
  fechado: 'volta_depois',
  sem_necessidade: 'volta_depois',
  estoque_cheio: 'volta_depois',
  preco_alto: 'perdeu',
  concorrente: 'perdeu',
  outro: 'outro',
}

export function situacaoDaVisita(visita: Visita | undefined): SituacaoVisita {
  if (!visita) return 'pendente'
  if (visita.resultado === 'com_pedido') return 'comprou'
  return visita.motivo_sem_pedido ? GRUPO_DO_MOTIVO[visita.motivo_sem_pedido] : 'outro'
}

export function rotuloDaVisita(visita: Visita | undefined): string {
  if (!visita) return ''
  if (visita.resultado === 'com_pedido') return 'Comprou'
  return visita.motivo_sem_pedido ? ROTULO_MOTIVO[visita.motivo_sem_pedido] : 'Outro motivo'
}

// Mesmo esquema de pedidos/estagio.ts: cartao inteiro pintado, faixa da esquerda
// mais forte, para a lista se ler por blocos de cor.
//
// PENDENTE e a excecao proposital, escolha dela em 08/08: fica BRANCO e legivel
// no sol. Neste app cor pesada significa "ja resolvido, o olho pula por cima" --
// e o pendente e justo o cartao que precisa ser lido e tocado.
export const CLASSE_CARTAO_SITUACAO: Record<SituacaoVisita, string> = {
  pendente: 'bg-white border-slate-800',
  comprou: 'bg-emerald-200 border-emerald-700',
  volta_depois: 'bg-yellow-100 border-yellow-500',
  perdeu: 'bg-red-200 border-red-700',
  outro: 'bg-slate-100 border-slate-400',
}

// Tela Rota (decisao dela 08/10): a COR DO NUMERO da parada diz a situacao --
// a mesma familia de cores do cartao. Pendente fica no verde do app.
export const CLASSE_NUMERO_SITUACAO: Record<SituacaoVisita, string> = {
  pendente: 'bg-teal-800',
  comprou: 'bg-emerald-600',
  volta_depois: 'bg-yellow-500',
  perdeu: 'bg-red-600',
  outro: 'bg-slate-400',
}

export const CLASSE_SELO_SITUACAO: Record<SituacaoVisita, string> = {
  pendente: 'bg-slate-100 text-slate-600',
  comprou: 'bg-emerald-100 text-emerald-800',
  volta_depois: 'bg-yellow-100 text-yellow-800',
  perdeu: 'bg-red-100 text-red-700',
  outro: 'bg-slate-100 text-slate-600',
}
